<template>
  <div class="orders-data-stats">
    <v-toolbar color="red accent-2" dark>
      <v-toolbar-title>Statistics</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-card>
        <v-card-title class="pa-4 my-2">Filters</v-card-title>
        <v-card-text class="pa-4 my-2">
          <v-row class="d-flex align-center">
            <v-col cols="12" sm="2">Pick Price (€)</v-col>
            <v-spacer></v-spacer>
            <v-col class="px-4" align="center" cols="2" sm="2">
              <v-text-field
                :value="range[0]"
                class="mt-0 pt-0"
                hide-details
                single-line
                disabled
                type="number"
                style="width: 60px"
              ></v-text-field>
            </v-col>
            <v-col class="px-4" align="center" cols="8" sm="6">
              <v-range-slider
                v-model="range"
                :max="max"
                :min="min"
                hide-details
                class="align-center"
              ></v-range-slider>
            </v-col>
            <v-col class="px-4" align="center" cols="2" sm="2">
              <v-text-field
                :value="range[1]"
                class="mt-0 pt-0"
                hide-details
                single-line
                disabled
                type="number"
                style="width: 60px"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex align-center">
            <v-col cols="12" sm="2">Pick Hours</v-col>
            <v-spacer></v-spacer>
            <v-col class="px-4" align="center" cols="2" sm="2">
              <v-text-field
                :value="getTimeFromNumber(rangeHours[0])"
                class="mt-0 pt-0"
                hide-details
                single-line
                disabled
                type="string"
                style="width: 60px"
              ></v-text-field>
            </v-col>
            <v-col class="px-4" align="center" cols="8" sm="6">
              <v-range-slider
                v-model="rangeHours"
                :max="maxHours"
                :min="minHours"
                hide-details
                class="align-center"
              ></v-range-slider>
            </v-col>
            <v-col class="px-4" align="center" cols="2" sm="2">
              <v-text-field
                :value="getTimeFromNumber(rangeHours[1])"
                class="mt-0 pt-0"
                hide-details
                single-line
                disabled
                type="string"
                style="width: 60px"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card v-if="orders.length" class="pa-4">
        <v-card-title class>
          <p class="font-weight-bold">Total:&nbsp;{{filteredOrders.length}}</p>
          <v-spacer></v-spacer>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="red accent-2" class="elevation-4" outlined v-bind="attrs" v-on="on">
                <v-icon left>mdi-filter-outline</v-icon>
                <span>Field</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                @click="selectedViz = item.title"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-title>
        <bar-chart :chart-data="currentStats" :options="chartOptions"></bar-chart>
        <v-data-table
          :headers="headers"
          :items="currentFigures"
          hide-default-header
          class="elevation-4 mt-2"
          dense
        ></v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import moment from "moment-timezone";
import _ from "lodash";
import BarChart from "@/BarChart.js";

export default {
  components: { BarChart },
  props: {
    orders: { type: Array },
    concepts: { type: Array },
    kitchens: { type: Array },
    platforms: { type: Array },
    countries: { type: Array },
  },
  data: function () {
    return {
      items: [
        { title: "Concepts" },
        { title: "Kitchens" },
        { title: "Platforms" },
        { title: "Countries" },
        { title: "Status" },
        { title: "Shifts" },
      ],
      headers: [
        {
          text: "Label",
          align: "start",
          value: "label",
        },
        { text: "Value", value: "value" },
      ],
      selectedViz: "Concepts",
      chartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        maintainAspectRatio: false,
      },
      min: 0,
      range: [0, 100],
      minHours: 0,
      maxHours: 1440,
      rangeHours: [0, 1440],
    };
  },
  watch: {
    max() {
      this.range[1] = this.max;
    },
  },
  computed: {
    max() {
      if (this.orders.length) {
        let max = _.maxBy(this.orders, "price_in_euros");
        return max.price_in_euros + 1;
      }
      return 100;
    },
    conceptFigures() {
      let stats = this.getStats("concept_uuid", this.concepts, "label");
      return this.getFigures(stats);
    },
    kitchenFigures() {
      let stats = this.getStats("kitchen_uuid", this.kitchens, "id");
      return this.getFigures(stats);
    },
    platformFigures() {
      let stats = this.getStats("platform_uuid", this.platforms, "label");
      return this.getFigures(stats);
    },
    countryFigures() {
      let countries = _.countBy(this.filteredOrders, "country_code");
      let stats = {};
      for (let [key, value] of Object.entries(countries)) {
        var el = this.countries.find((obj) => obj.id === key);
        stats[el.label] = value;
      }
      return this.getFigures(stats);
    },
    shiftFigures() {
      let stats = _.countBy(this.filteredOrders, "shift");
      return this.getFigures(stats);
    },
    statusFigures() {
      let stats = _.countBy(this.filteredOrders, "status");
      return this.getFigures(stats);
    },
    conceptStats() {
      let stats = this.getStats("concept_uuid", this.concepts, "label");
      return this.getDataset("Concept", stats);
    },
    kitchenStats() {
      let stats = this.getStats("kitchen_uuid", this.kitchens, "id");
      return this.getDataset("Kitchen", stats);
    },
    platformStats() {
      let stats = this.getStats("platform_uuid", this.platforms, "label");
      return this.getDataset("Platform", stats);
    },
    countryStats() {
      let countries = _.countBy(this.filteredOrders, "country_code");
      let stats = {};
      for (let [key, value] of Object.entries(countries)) {
        var el = this.countries.find((obj) => obj.id === key);
        stats[el.label] = value;
      }
      return this.getDataset("Country", stats);
    },
    shiftStats() {
      let stats = _.countBy(this.filteredOrders, "shift");
      return this.getDataset("Shift", stats);
    },
    statusStats() {
      let stats = _.countBy(this.filteredOrders, "status");
      return this.getDataset("Status", stats);
    },
    currentStats() {
      let stats = this.conceptStats;
      if (this.selectedViz === "Kitchens") {
        stats = this.kitchenStats;
      }
      if (this.selectedViz === "Platforms") {
        stats = this.platformStats;
      }
      if (this.selectedViz === "Countries") {
        stats = this.countryStats;
      }
      if (this.selectedViz === "Shifts") {
        stats = this.shiftStats;
      }
      if (this.selectedViz === "Status") {
        stats = this.statusStats;
      }
      return stats;
    },
    currentFigures() {
      let figures = this.conceptFigures;
      if (this.selectedViz === "Kitchens") {
        figures = this.kitchenFigures;
      }
      if (this.selectedViz === "Platforms") {
        figures = this.platformFigures;
      }
      if (this.selectedViz === "Countries") {
        figures = this.countryFigures;
      }
      if (this.selectedViz === "Shifts") {
        figures = this.shiftFigures;
      }
      if (this.selectedViz === "Status") {
        figures = this.statusFigures;
      }
      return figures;
    },
    filteredOrders() {
      return this.orders.filter((order) => {
        let date_at = order.ready_at.length ? order.ready_at : order.placed_at;
        let date = this.convertFromStringToDateNumber(date_at, order.timezone);
        let isInPriceRange =
          order.price_in_euros >= this.range[0] &&
          order.price_in_euros <= this.range[1];
        let isInDateRange =
          date >= this.rangeHours[0] && date <= this.rangeHours[1];
        return isInPriceRange && isInDateRange;
      });
    },
  },
  methods: {
    convertFromStringToDateNumber(string, timeZone) {
      let date_utc = moment.utc(string, "YYYY-MM-DDTHH:mm:ssZ");
      let date = date_utc.clone().tz(timeZone);
      return date.hour() * 60 + date.minutes();
    },
    getTimeFromNumber(number) {
      let hour = Math.floor(number / 60);
      let minutes = Math.ceil((number / 60 - Math.floor(number / 60)) * 60);
      let hourStr =
        String(hour).length == 1 ? "0" + String(hour) : String(hour);
      let minutesStr =
        String(minutes).length == 1 ? "0" + String(minutes) : String(minutes);
      return `${hourStr}:${minutesStr}`;
    },
    getElementByUuid(uuid, list) {
      return list.find((obj) => obj.uuid === uuid);
    },
    getStats(groupField, list, searchField) {
      let groupedList = _.countBy(this.filteredOrders, groupField);
      let stats = {};
      for (let [key, value] of Object.entries(groupedList)) {
        var el = this.getElementByUuid(key, list);
        stats[el[searchField]] = value;
      }
      return stats;
    },
    getFigures(stats) {
      let figures = [];
      Object.entries(stats).forEach(([key, value]) => {
        figures.push({
          label: key,
          value: value,
        });
      });
      return figures;
    },
    getDataset(label, stats) {
      return {
        labels: Object.keys(stats),
        datasets: [
          {
            label: label,
            data: Object.values(stats),
            backgroundColor: "#FF5252",
          },
        ],
      };
    },
  },
};
</script>
